import { render, staticRenderFns } from "./AddAssetsModal.vue?vue&type=template&id=09a4b447"
import script from "./AddAssetsModal.vue?vue&type=script&lang=js"
export * from "./AddAssetsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports